








import {Component, Vue} from 'vue-property-decorator';
import {Getter} from 'vuex-class';
import {AUTH_GET_CLIENT} from '@/store/modules/authentication/types';
import {Client} from '@/store/modules/authentication/interfaces';
import {TupleDictionary} from '@/utils/tupleDictionary';
import {ClientEnum} from '@/enums/client.enum';
import ReportPowerBiContainer from '@/modules/neodash/components/report-powerbi-container/report-powerbi-container.vue';
import {traceLogAccess} from '@/services';
import {ContextEnum} from '@/enums/context.enum';
import PbiDictWorkspaceId, { PbiWorkspacesEnum } from '@/modules/neodash/containers/powerbi/pbi-dict-workspace-id';

@Component({
  name: 'PbiDashboardSalesReport',
  components: { ReportPowerBiContainer }
})
export default class PbiDashboardSalesReportPage extends Vue {
  @Getter(AUTH_GET_CLIENT)
  public client: Client;

  private pbiDictWorkspaceId = new PbiDictWorkspaceId();
  public dictReports = new TupleDictionary<[ClientEnum], IPbiContainer>();
  public crrReport: IPbiContainer = { brand: '', workspaceId: '', reportId: '' };

  mounted() {
    this.dictReports.set([ClientEnum.Mitsubishi], { brand: 'Mitsubishi', workspaceId: this.pbiDictWorkspaceId.dictionary.get([PbiWorkspacesEnum.Neodash]), reportId: '406df88e-097e-4abe-a407-674cbedf302b' });
    this.crrReport = this.dictReports.get([this.client.id]);
    traceLogAccess.logAction(ContextEnum.Report, `${this.crrReport.brand} - Dashboard Sales Report`);
  }
}
